import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import moment from "moment";
import "moment-timezone";
import { BACKEND } from "../config/configEnvs";
import {
  FaExclamationCircle,
  FaPlus,
  FaEye,
  FaClone,
  FaTrashAlt,
  FaEdit,
  FaFilter,
  FaExternalLinkAlt
} from "react-icons/fa";
import { toast } from "react-toastify";
import AddIcon from '@mui/icons-material/Add';
import getActiveWorkers from "../utils/getData/getActiveWorkers";
import { Button } from "@mui/material";
import LoadingScreen from "../components/ui/temp-screens/LoadingScreen";
import NoDataScreen from "../components/ui/temp-screens/NoDataScreen";
import PaginationItem from "../components/ui/components/Pagination";
import Tooltip from "../components/ui/ToolTip";
import Modal from "../components/ui/Modal";
import {months, years} from "../utils/rawData/dateValues";
import { formatDate } from "../utils/rawData/dateValues";
import EditButton from "../components/ui/components/EditButton";
import DuplicateButton from "../components/ui/components/DuplicateButton";
import DeleteButton from "../components/ui/components/DeleteButton";
import DetailsButton from "../components/ui/components/DetailsButton";
function Incidencias() {
  
  const [loading, setLoading] = useState(false);

  const [incidences, setIncidences] = useState([]);

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(50);
  const [totalDocs, setTotalDocs] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [year, setYear] = useState(new Date().getFullYear());

  const [openModalDetails, setOpenModalDetails] = useState(false);
  const [selectedIncidence, setSelectedIncidence] = useState(null);

  const [workers, setWorkers] = useState([]);
  const [selectedWorker, setSelectedWorker] = useState("");

  const getIncidences = async () => {
    try {
      setLoading(true);
      let url = `${BACKEND}/api/incidencias?page=${page}&limit=${limit}`;

      if (month) url += `&where[month][equals]=${month}`;
      if (year) url += `&where[year][equals]=${year}`;
      if (selectedWorker) url += `&where[trabajador][equals]=${selectedWorker}`;

      const response = await axios.get(url);

      console.log(response);
      setTotalDocs(response.data.totalDocs);
      setTotalPages(response.data.totalPages);
      setIncidences(response.data.docs);
    } catch (error) {
      toast.error("Error al obtener las incidencias");
    } finally {
      setLoading(false);
    }
  }

  const handlePageChange = (event, value) => { // Cambiar la página
    setPage(value)
  }

  const handleDelete = async (incidencia) => {
  const confirmed = window.confirm(
    "¿Estás seguro de que deseas eliminar esta incidencia? Se eliminarán las pruebas"
  );

  if (confirmed) {
    try {
      if (incidencia.pruebas && incidencia.pruebas.length) {
        await Promise.all(
          incidencia.pruebas.map(async (prueba) => {
            try {
              await axios.delete(`${BACKEND}/api/incidenciasMedia/${prueba.id}`);
            } catch (deleteError) {
              toast.warning(`Error al eliminar imagen con ID ${prueba.id}:`, deleteError);
            }
          })
        );
      }

      await axios.delete(`${BACKEND}/api/incidencias/${incidencia.id}`);

      const updatedIncidences = incidences.filter(
        (item) => item.id !== incidencia.id
      );
      setIncidences(updatedIncidences);
      toast.success("Incidencia eliminada exitosamente");

    } catch (e) {
      toast.error("Error al eliminar la incidencia: " + e);
    }
  }
  };

  const handleDuplicate = async (incidenceId) => {
  try {
    const originalIncidence = incidences.find((inc) => inc.id === incidenceId)
    const newIncidence = {
      ...originalIncidence,
      id: undefined,
      //Duplicamos las relaciones de las imagenes? recomendación, NO, las seteamos en un array vacío
      pruebas: [],
      trabajador: originalIncidence.trabajador.id,
      titulo: `${originalIncidence.titulo} (copia)`,
      createdAt: undefined,
      updatedAt: undefined,
    };
    const response = await axios.post(`${BACKEND}/api/incidencias`, newIncidence);

    if (response.status === 201) {
      toast.success("Registro duplicado exitosamente");
    }
    getIncidences();

  } catch (e) {
    toast.error("Hubo un error al crear el registro: " + e);
  }
};

  useEffect(() => {
    getIncidences();
    getActiveWorkers(setWorkers);
  }, []);

  useEffect(() => {
    getIncidences();
  }, [page, limit, month, year, selectedWorker]);

  const colorMap = {
    "Leve": "text-yellow-300",
    "Moderada": "text-yellow-500",
    "Grave": "text-red-500",
    "Muy grave": "text-red-800"
  }

  const totalDescuentos = incidences.reduce((acc, inc) => acc + (inc.descuento || 0), 0);

  return (
    <div className="flex flex-col h-screen w-full">

      <Modal
        activeModal={openModalDetails}
        onClose={() => setOpenModalDetails(false)}
        title="Detalles de la incidencia"
        className="max-w-3xl"
        centered
      >
        <div className="flex flex-wrap text-xs text-gray-700">
          {/* Detalles de la incidencia */}
          <div className="w-full md:w-1/2 rounded-md">
            <div className="mb-4">
              <span className="font-semibold">Gravedad:</span>                     
                <span
                  className={`font-semibold
                    ${selectedIncidence?.gravedad === "Leve" ? "text-yellow-300" : ""}
                    ${selectedIncidence?.gravedad === "Moderada" ? "text-yellow-500" : ""}
                    ${selectedIncidence?.gravedad === "Grave" ? "text-red-500" : ""}
                    ${selectedIncidence?.gravedad === "Muy grave" ? "text-red-800" : ""}`}
                >
                  {" " + selectedIncidence?.gravedad || "N/A"}
                </span>
            </div>
            <div className="mb-4">
              <span className="font-semibold">Autor:</span> {selectedIncidence?.autor || "N/A"}
            </div>
            <div className="mb-4">
              <span className="font-semibold">Trabajador:</span> {selectedIncidence?.trabajador?.name}
            </div>
            <div className="mb-4">
              <span className="font-semibold">Motivo:</span> {selectedIncidence?.titulo}
            </div>
            <div className="mb-4">
              <span className="font-semibold">Comentario:</span> {selectedIncidence?.comentario || "N/A"}
            </div>
            <div className="mb-4">
              <span className="font-semibold">Fecha de creación:</span>                     
                {selectedIncidence?.fecha
                  ? " " + moment.utc(selectedIncidence?.fecha).format("DD/MM/YYYY")
                  : ""
                }
            </div>
            
            <div className="mb-4">
              <span className="font-semibold">Descuento:</span> {selectedIncidence?.descuentoPorDefinir ? "Por definir" : "S/. " + selectedIncidence?.descuento}
            </div>

            <div className="mb-4">
              <span className="font-semibold">Subsanado:</span> {selectedIncidence?.subsanado}
            </div>

            {selectedIncidence?.fechaSubsanacion && (
              <div className="mb-4">
                <span className="font-semibold">Fecha de subsanación:</span>
                {selectedIncidence?.fechaSubsanacion
                  ? " " + moment.utc(selectedIncidence?.fechaSubsanacion).format("DD/MM/YYYY")
                  : ""
                }
              </div>
            )}

            {selectedIncidence?.comentarioSubsanacion && (
              <div className="mb-4">
                <span className="font-semibold">Comentario subsanacion:</span> {selectedIncidence?.comentarioSubsanacion}
              </div>
            )}
            <div className="mb-4">
              <span className="font-semibold">Links:</span>
              <ul className="list-disc mt-4">
                {selectedIncidence?.links?.length > 0 ? (
                  selectedIncidence?.links?.map((link, index) => (
                    <li key={index}>
                      <a href={link.link} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">
                        {link.link}
                      </a>
                    </li>
                  ))
                ) : (
                  <div className="w-full h-12 mt-4 flex items-center justify-center text-gray-600">
                    No hay links disponibles
                  </div>
                )}
              </ul>
            </div>
          </div>
          
          <div className="w-full md:w-1/2 overflow-y-auto rounded-md">
            <span className="font-semibold">Archivos adjuntos:</span>
            {selectedIncidence?.pruebas?.length > 0 ? (
              selectedIncidence?.pruebas?.map((prueba, index) => {
                const url = prueba.url;
                const name = prueba.filename;
                const mimeType = prueba.type;
                const fileType = prueba.mimeType?.split('/')[0] || '';

                return (
                  <div key={index} className="border p-3 rounded-md shadow mb-4 mt-4 bg-white hover:bg-gray-100 transition-all duration-300">
                    <div className="flex items-center justify-between mb-2">
                      <span className="font-medium">{name}</span>
                      <button
                        type="button"
                        onClick={() => window.open(url, '_blank')}
                        className="p-2 text-blue-500 hover:bg-blue-600 hover:bg-opacity-25 rounded-md bg-blue-700 bg-opacity-10 flex items-center"
                      >
                        <FaExternalLinkAlt />
                      </button>
                    </div>
                    {fileType === 'image' && (
                      <img src={url} alt={`Preview ${index}`} className="w-full h-auto rounded-md" />
                    )}
                    {fileType === 'video' && (
                      <video controls className="w-full h-auto rounded-md">
                        <source src={url} type={mimeType} />
                        Your browser does not support the video tag.
                      </video>
                    )}
                    {fileType === 'audio' && (
                      <audio controls className="w-full max-h-12 rounded-md">
                        <source src={url} type={mimeType} />
                        Your browser does not support the audio element.
                      </audio>
                    )}
                    {fileType !== 'image' && fileType !== 'video' && fileType !== 'audio' && (
                      <a href={url} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">
                        {url}
                      </a>
                    )}
                  </div>
                );
              })
            ) : (
              <div className="w-full flex-grow h-32 border border-gray-200 rounded-md mt-4 flex items-center justify-center text-gray-600">
                No hay archivos adjuntos
              </div>
            )}
          </div>
        </div>
  
      </Modal>

      {/* Header */}
      <div className="flex flex-row px-4 py-2 bg-gray-100">
        <div className="flex flex-row w-full items-center gap-4 justify-between overflow-x-auto">

          <div className="flex items-center gap-4 p-4">
            <FaExclamationCircle className="text-2xl text-gray-700" />
            <h2 className="text-2xl font-bold text-gray-700">Incidencias</h2>
          </div>

          <div className="flex flex-row gap-4 items-center justify-center">

            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
              <span>Límite:</span>
              <select
                value={limit}
                onChange={(e) => setLimit(e.target.value)}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              >
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>
            
            <div>
              <Link to="/home/incidencias/nueva-incidencia">
                <Button
                  variant="contained"
                  endIcon={<AddIcon/>}
                  sx={{
                    fontSize: "12px",
                    fontWeight: "bold",
                    fontFamily: "poppins",
                    whiteSpace: "nowrap",
                    padding: "4px 24px",
                    backgroundColor: "#ff6400",
                    transform: "all",
                    animationDuration: "1000",
                    textTransform: "none",
                    borderRadius: "8px",
                    '&:hover': {
                      backgroundColor: "#bb4a03",
                    }
                  }}
                >
                  Nueva incidencia
                </Button>
              </Link>
            </div>

          </div>

        </div>
        
      </div>

      {/* Resumen */}
      <div className="flex bg-gray-100 mt-0.5 w-full">
        <div className="w-full items-center justify-center overflow-x-auto py-1 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          <div className="flex flex-row gap-8 min-w-max px-4 items-center justify-center">         
            
            <div className="flex flex-row gap-2 items-center justify-center">
              <span className="block text-xs truncate font-medium text-gray-900">
                Incidencias:
              </span>
              <span className="block text-xs truncate font-medium text-gray-900">
                {incidences.length}
              </span>
            </div>
            <div className="flex flex-row gap-2 items-center justify-center">
              <span className="block text-xs truncate font-medium text-gray-900">
                Total descuentos:
              </span>
              <span className={`block text-xs truncate font-medium ${totalDescuentos > 0 ? "text-red-500" : "text-gray-900"}`}>
                S/. {totalDescuentos.toFixed(2)}
              </span>
            </div>

          </div>
        </div>
      </div>

      {/* Barra de filtros */}
      <div className="flex bg-gray-100 mt-0.5 mb-0.5 w-full gap-10">
        <div className="flex flex-row w-full items-center justify-center gap-8 overflow-x-auto px-4 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-2">
            <span className="truncate">Trabajador:</span>
            <select
              value={selectedWorker}
              onChange={(e) => setSelectedWorker(e.target.value)}
              className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-0 focus:border-gray-300 py-[6px] pr-10"
            >
              <option value={""}>Todos</option>
              {workers.map((worker) => (
                <option key={worker.id} value={worker.id}>{worker.name}</option>
              ))}
            </select>
          </div>

          <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-2">
            <span className="truncate">Mes:</span>
            <select
              value={month}
              onChange={(e) => setMonth(e.target.value)}
              className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-0 focus:border-gray-300 py-[6px] pr-10"
            >
              <option value={""}>Todos</option>
              {months.map((month) => (
                <option key={month.value} value={month.value}>{month.label}</option>
              ))}
            </select>
          </div>

          <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-2">
            <span className="truncate">Año:</span>
            <select
              value={year}
              onChange={(e) => setYear(e.target.value)}
              className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-0 focus:border-gray-300 py-[6px] pr-10"
            >
              <option value={""}>Todos</option>
              {years.map((year) => (
                <option key={year.value} value={year.value}>{year.label}</option>
              ))}
            </select>
          </div>
        </div>
      </div>

      {/* Body */}
      <div className={`flex-grow overflow-y-auto`}>
        {loading ? (
          <LoadingScreen />
            ) : incidences.length === 0 ? (
            <NoDataScreen />
            ) : (
            <table className="w-full text-xs">
              <thead className="sticky top-0 text-gray-900 bg-gray-200 text-[10px]">
                <tr className="text-gray-700 text-center font-bold">
                  <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                    Acciones
                  </td>
                  <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                    Detalles
                  </td>
                  <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                    Gravedad
                  </td>
                  <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                    Trabajador
                  </td>
                  <td className="px-2 py-3 text-center bg-[#FE6400] min-w-[200px] border-r border-r-white text-white border-red">
                    Motivo
                  </td>
                  <td className="px-2 py-3 text-center bg-[#FE6400] min-w-[350px] border-r border-r-white text-white border-red">
                    Comentario
                  </td>
                  <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                    Descuento
                  </td>
                  <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                    Fecha
                  </td>
                  <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                    Mes
                  </td>
                  <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                    Año
                  </td>
                  <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                    Subsanado
                  </td>
                  <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                    Fecha subsanación
                  </td>
                  <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                    Comentario subsanación
                  </td>
                </tr>
              </thead>
              <tbody>
                {incidences.map((i) => (
                  <tr key={i.id} className="py-2 w-full hover:bg-gray-100 transition-all duration-100">
                    <td className={`px-6 py-2 max-w-xs truncate border border-gray-300 text-center`}>
                      <div className="flex items-center justify-center gap-2">
                        <Link to={`/home/incidencias/editar-incidencia/${i.id}`}>
                          <EditButton content="Editar incidencia" />
                        </Link>
                        <DuplicateButton action={() => handleDuplicate(i.id)} content="Duplicar incidencia" />
                        <DeleteButton action={() => handleDelete(i)} content="Eliminar incidencia" />
                      </div>
                    </td>
                    <td className="px-6 py-2 max-w-xs truncate border border-gray-300 text-center">
                      <div className="flex items-center justify-center">
                        <DetailsButton action={() => {
                          setSelectedIncidence(i)
                          setOpenModalDetails(true)
                        }} content="Detalles" />
                      </div>
                    </td>
                    <td className={`px-6 py-2 max-w-xs font-bold truncate border border-gray-300 text-center ${colorMap[i.gravedad]}`}>
                      {i.gravedad}
                    </td>
                    <td className={`px-6 py-2 max-w-xs truncate border border-gray-300 text-center`}>
                      {i.trabajador.name}
                    </td>
                    <td className={`px-6 py-2 max-w-xs border border-gray-300 text-center`}>
                      {i.titulo}
                    </td>
                    <td className={`px-6 py-2 max-w-xs border border-gray-300 text-center`}>
                      {i.comentario}
                    </td>
                    <td className={`${i.descuento ? "text-black" : "text-gray-200"} px-6 py-2 max-w-xs truncate border border-gray-300 text-center`}>
                      {i.descuento ? `S/ ${i.descuento}` : "No definido"}
                    </td>
                    <td className={`px-6 py-2 max-w-xs truncate border border-gray-300 text-center`}>
                      {formatDate(i.fecha.split("T")[0])}
                    </td>
                    <td className={`px-6 py-2 max-w-xs truncate border border-gray-300 text-center`}>
                      {months[i.month - 1]?.label || i.month}
                    </td>
                    <td className={`px-6 py-2 max-w-xs truncate border border-gray-300 text-center`}>
                      {i.year}
                    </td>
                    <td className={`${i.subsanado ? "text-black" : "text-gray-200"} px-6 py-2 max-w-xs truncate border border-gray-300 text-center`}>
                      {i.subsanado || "No definido"}
                    </td>
                    <td className={`${i.fechaSubsanacion ? "text-black" : "text-gray-200"} px-6 py-2 max-w-xs truncate border border-gray-300 text-center`}>
                      {i.fechaSubsanacion ? formatDate(i.fechaSubsanacion.split("T")[0]) : "No definido"}
                    </td>
                    <td className={`${i.comentarioSubsanacion ? "text-black" : "text-gray-200"} px-6 py-2 max-w-xs truncate border border-gray-300 text-center`}>
                      {i.comentarioSubsanacion || "No definido"}
                    </td>
                  </tr>
                ))}

              </tbody>
            </table>
          )
        }
      </div>

      {/* Paginador */}
      <PaginationItem
        actualDocs={incidences.length}
        totalDocs={totalDocs}
        entity={"incidencias"}
        totalPages={totalPages}
        actualPage={page}
        handlePageChange={handlePageChange}
      />
    </div>
  );
}

export default Incidencias;